import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { hosClockViolationRefs } from "../subjects/hosClockViolation/refs";
import { HosClockHoursSchema } from "./breakOverdue";

/**
 * The driver's driving clock ran out.
 */
export const drivingLimitExceededV1 = tmsEventKind(
  { category: "hoursOfService", kind: "drivingLimitExceeded", version: 1 },
  {
    refs: hosClockViolationRefs,
    facts: {
      /** The clock's length in hours, as the vendor labels it. */
      clockHours: HosClockHoursSchema,
    },
  },
);

export const DrivingLimitExceededV1Schema = drivingLimitExceededV1.schema;
export const DrivingLimitExceededV1FactsSchema = drivingLimitExceededV1.facts;

export type DrivingLimitExceededV1 = z.infer<typeof DrivingLimitExceededV1Schema>;
export type DrivingLimitExceededV1Facts = z.infer<typeof DrivingLimitExceededV1FactsSchema>;

/** Every version of `drivingLimitExceeded`, keyed by version. What `catalog.ts` places under `hoursOfService`. */
export const drivingLimitExceeded = { 1: drivingLimitExceededV1 } as const;
